import type { ReactNode } from 'react'
import { PromptTemplateTablePanel } from '@/components/prompt-templates/prompt-template-table-panel.molecule'
import { usePromptTemplateTable } from '@/components/prompt-templates/use-prompt-template-table.hook'

export const PromptTemplatesListView = (): ReactNode => {
  const tableState = usePromptTemplateTable()

  return (
    <div className="prompt-templates-list-wrapper">
      <PromptTemplateTablePanel {...tableState} />
    </div>
  )
}
